import { useState } from 'react';

import { Modal } from '@iwoca/orion';
import { FormattedMessage } from 'react-intl';

import messages from './MajorShareholderCheckAction.messages';
import { FundingStepActionButton } from '../fundingStepActionButton/FundingStepActionButton';
import { TFundingRequirementsSteps } from '../orderFundingRequirements';
import MSHModal from './mshModal/MSHModal';
import StepItem from '../stepItem/StepItem';

const MajorShareholderCheckAction = ({
    status
}: {
    status: TFundingRequirementsSteps['0']['status'];
}) => {
    const [isModalOpen, setIsModalOpen] = useState(false);

    const handleModalClose = () => {
        setIsModalOpen(false);
    };
    return (
        <>
            <StepItem
                title={<FormattedMessage {...messages.title} />}
                caption={<FormattedMessage {...messages.caption} />}
                action={
                    <FundingStepActionButton
                        actionMessage={
                            <FormattedMessage {...messages.action} />
                        }
                        pendingMessage={
                            <FormattedMessage {...messages.pending} />
                        }
                        status={status}
                        handleFundingStepAction={() => setIsModalOpen(true)}
                        stepName="Major shareholder check"
                    />
                }
            />
            <Modal isOpen={isModalOpen} onClose={handleModalClose} closeIcon>
                <MSHModal onClose={handleModalClose} />
            </Modal>
        </>
    );
};

// eslint-disable-next-line import/no-default-export
export default MajorShareholderCheckAction;
